import 'react-toggle/style.css';
import styled from 'styled-components';

import IQVeraComponents from 'src/ServerEntities/IQVeraComponents';

import { useNavigate } from 'react-router-dom';
import IQVeraChannel from 'src/ServerEntities/IQVeraChannel';
import IQVeraDestination from 'src/ServerEntities/IQVeraDestination';

const OuterContainer = styled.div`
    border-radius: 25px;
    border: 5px solid #44A2D6;
    padding: 2px;
`;

const InnerContainer = styled.div`
    padding-bottom: 20px;
    padding-top: 30px;
    padding-left: 5px;
    padding-right: 5px;
`;

const TitleBar = styled.div`
    border-radius: 20px;
    background-color: #1577AE;
    padding: 5px;
    color: #FFF;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
    cursor: pointer;
`;

const IntersystemStateBubble = styled.div`
    border-radius: 15px;
    padding: 1px;
    padding-bottom: 2px;
    min-width: 70px;
    text-align: center;
    font-size: 0.8em;
    font-weight: bold;
    &.ERRORED {
        background-color: #F00;  /* Red background */
        color: #FFF;  /* White text */
    }
    &.STOPPED {
        background-color: #cccccc;
    }
    &.RETRYING {
        background-color:rgb(231, 139, 0);
    }
    &.NOTCONFIGURED {
        background-color: #555555;
        color: #ffffff;
    }
    &.RUNNING {
        background-color:rgb(0, 232, 0);
    }
`;


const Footer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 5px
`;

const ComponentContainer = styled.div`
   margin-top: 5px;
   margin-bottom: 5px
`;

const ComponentHeader = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 5px;
    font-weight: bold;
    justify-content: space-evenly
`;

const BarItem = styled.div`
    &.ERROR {
      color: #F00;
    }
    &.STOPPED {
      color: #cccccc;
    }
    &.RETRYING {
      color:rgb(231, 139, 0);
    }
    &.NOTCONFIGURED {
      color: #555555;
    }
    &.RUNNING  {
      color:rgb(0, 232, 0);
    }
`;

interface IProps {
    data: IQVeraComponents;
};

const renderQVeraState = (state: string) => {
    switch(state.toLocaleUpperCase()) {
         case "ERRORED":   return <IntersystemStateBubble className={state}>ERRORED</IntersystemStateBubble>
         case "STOPPED": return <IntersystemStateBubble className={state}>STOPPED</IntersystemStateBubble>
         case "RETRYING": return <IntersystemStateBubble className={state}>RETRYING</IntersystemStateBubble>
         case "RUNNING": return <IntersystemStateBubble className={state}>RUNNING</IntersystemStateBubble>
         case "NOTCONFIGURED": return <IntersystemStateBubble className={state}>NOT CONFIGURED</IntersystemStateBubble>
    }
    return null;
};

const QVeraComponentPanel = (props: IProps) => {
    const { data } = props;
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/Ram/QVera Components');
    };

    const renderComponent = (name: string, components:  Array<IQVeraChannel | IQVeraDestination>) => {
        if (!components || !Array.isArray(components)) {
            return null;
        }
        const normalizeState = (state: string) => state?.replace(/\s+/g, '').replace(/_/g, '').toUpperCase() || '';
        const total = components.length;
        const errorCount = components.filter(c => normalizeState(c.state) === "ERROR").length;
        const retryingCount = components.filter(c => normalizeState(c.state) === "RETRYING").length;
        const stoppedCount = components.filter(c => normalizeState(c.state) === "STOPPED").length;
        const runningCount = components.filter(c => normalizeState(c.state) === "RUNNING").length;
        const notConfiguredCount = components.filter(c => normalizeState(c.state) === "NOTCONFIGURED").length;
    
        const errorWidth = (errorCount / total) * 100;
        const retryingWidth = (retryingCount / total) * 100;
        const stoppedWidth = (stoppedCount / total) * 100;
        const notConfiguredWidth = (notConfiguredCount / total) * 100;
        const runningWidth = (runningCount / total) * 100;

        return (
            <ComponentContainer>
                <ComponentHeader>
                    <div style={{ width: "50%" }}>{name}</div>
                    <div style={{ width: "10%" }}>{total}</div>
                    <BarItem className='ERROR' style={{ width: "10%" }}>{errorCount}</BarItem>
                    <BarItem className='STOPPED' style={{ width: "10%" }}>{stoppedCount}</BarItem>
                    <BarItem className='RETRYING' style={{ width: "10%" }}>{retryingCount}</BarItem>
                    <BarItem className='RUNNING' style={{ width: "10%" }}>{runningCount}</BarItem>
                    <BarItem className='NOTCONFIGURED' style={{ width: "10%" }}>{notConfiguredCount}</BarItem>
                </ComponentHeader>

                <div style={{ display: 'flex', width: '100%', height: '20px', border: '0px solid black', borderRadius: '10px', overflow: 'hidden' }}>
                    <div style={{ width: `${errorWidth}%`, backgroundColor: 'red', borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }}></div>
                    <div style={{ width: `${stoppedWidth}%`, backgroundColor: '#cccccc' }}></div>
                    <div style={{ width: `${retryingWidth}%`, backgroundColor: '#e78b00' }}></div>
                    <div style={{ width: `${runningWidth}%`, backgroundColor: '#00e800' }}></div>
                    <div style={{ width: `${notConfiguredWidth}%`, backgroundColor: '#555555', borderTopRightRadius: '10px', borderBottomRightRadius: '10px' }}></div>
                </div>
            </ComponentContainer >
        );
    };

    return <OuterContainer>
        <TitleBar onClick={handleClick}>Components</TitleBar>
        <InnerContainer>
            {data && data.channels && renderComponent("Channels", data.channels)}
            {data && data.destinations && renderComponent("Destinations", data.destinations)}
        </InnerContainer>
        <Footer>
            {renderQVeraState("ERRORED")}
            {renderQVeraState("STOPPED")}
            {renderQVeraState("RETRYING")}
            {renderQVeraState("RUNNING")}
            {renderQVeraState("NOTCONFIGURED")}
        </Footer>
    </OuterContainer>;
};
export default QVeraComponentPanel;

